import React, { useEffect, useLayoutEffect } from 'react';
import styles from './ExploreOrbit.module.scss'
import GroundData from "../GroundData/GroundData";
import OrbitElementsSimulator from "../OrbitElementsSimulator/OrbitElementsSimulator";
import TabbedModal from "../TabbedModal/TabbedModal";
import Button from "../../../partials/Button";
import { OrbitsContext } from "../Context/OrbitsContext";
import BackButton from "../../../partials/Button/BackButton";

var FIRST_RENDER_LOADING_FLAG = true;

function ExploreOrbit({ orbit, dispatchers, onGoBack, onContinue }) {

    const [view, setView] = React.useState('exploreorbit');
    const [orbitColor, setOrbitColor] = React.useState();
    const [errorMsg, setErrorMsg] = React.useState();
    const [selectedUserValues, setSelectedUserValues] = React.useState();
    const orbitsState = React.useContext(OrbitsContext)

    useEffect(() => {
        dispatchers.setCurrentBackground('grid')
        FIRST_RENDER_LOADING_FLAG = false;

        return () => {
            FIRST_RENDER_LOADING_FLAG = true;
        }
    }, [])

    const getValues = aspect => {
        try {
            const orbitGroundData = orbitsState.groundData[orbit.header.toLowerCase()]
            const aspectValues = [...new Set(orbitGroundData.map(d => d[aspect]))]

            return aspectValues.sort(function (a, b) {
                return a - b
            })

        } catch (e) {
            console.error("Invalid Orbit groundData for :" + orbit.header.toLowerCase())
            console.log(e.message)
        }
        return [];
    }

    const smaValues = getValues('sma')
    const incValues = getValues('inc')
    const eccValues = getValues('ecc')

    const [selectedOrbitData, setCurrentSelectedOrbitData] = React.useState({
        sma: smaValues,
        inc: incValues,
        ecc: eccValues,
    })

    const [currentSelectedAspect, setCurrentSelectedAspect] = React.useState('sma')

    if (!orbit) return null

    var valuesValidation = (h, onValid) => {
        // TODO: Hook Up Ground Data.
        if (!h.sma) return

        // setCurrentSelectedOrbitData(h)
        const orbitGroundData = orbitsState.groundData[orbit.header.toLowerCase()]
            ? orbitsState.groundData[orbit.header.toLowerCase()]
            : []

        const smaTracks = orbitGroundData.filter(
            t => {
                return t.sma === h.sma &&
                    t.ecc === h.eccentricity &&
                    t.inc === h.inclination
            }
        )

        if (smaTracks.length < 1) {
            if (FIRST_RENDER_LOADING_FLAG === true) return;
            setOrbitColor(smaTracks.length < 1 ? "red" : undefined)
            setErrorMsg(smaTracks.length < 1 ? "Adjust your SMA, inclination or eccentricity in order to view another orbit" : undefined)

        } else {

            const failReason = smaTracks.find(t => t.isGood === false && t.reason !== '')
            if (failReason) {
                setErrorMsg(failReason.reason)
            } else {
                setErrorMsg(undefined)
                setOrbitColor(undefined)
                if (onValid) onValid();
            }
        }
    }

    return <div className={styles.ExploreOrbit}>
        <div className="back-btn-container" style={{ zIndex: 10 }} >
            <Button variant={'back'} text={'BACK'} onClick={() => {
                if (view === 'exploreaspects') {
                    setView('exploreorbit')
                    return
                }
                if (view === 'exploreorbit') {
                    onGoBack()
                    return
                }
            }} />
        </div>
        <div className={styles.Simulator}>
            <div className={styles.Spacer} />
            <div className={styles.GroundData}>
                <div className={styles.Globe}>
                    <OrbitElementsSimulator
                        doAltitude={true}
                        orbit={orbit}
                        perigee={orbit?.orbitData?.perigee || orbit?.orbitData?.sma}
                        sma={orbit?.orbitData?.sma}
                        inc={orbit?.orbitData?.inc}
                        ecc={orbit?.orbitData?.ecc}
                        SMAValues={smaValues}
                        InclinationValues={incValues}
                        EccentricityValues={eccValues}
                        showSummary={view !== 'challenge'}
                        showSliders={view === 'exploreaspects'}
                        orbitColor={orbitColor}
                        errorMsg={errorMsg}
                        onErrorClick={() => setErrorMsg(undefined)}
                        onSlidersChange={(h) => {
                            // valuesValidation(h)
                            setSelectedUserValues(h)
                        }}
                        onSliderClick={(h) => {
                            setCurrentSelectedAspect(h.toLowerCase())
                        }}
                    />
                </div>

            </div>
        </div>
        <div className={styles.TabbedContent}>
            {
                view === 'exploreorbit' && (<><div className={styles.Title}>{orbitsState?.config?.exploreFactsHeader || 'Explore the orbit facts and continue'}</div>
                    <TabbedModal data={orbit} />
                    <Button
                        onClick={() => setView('exploreaspects')}
                        Dog className={styles.ContinueButton}
                        text={'CONTINUE'}
                    >
                    </Button>
                </>)
            }
            {
                view === 'exploreaspects' && (
                    <><div className={styles.Title}>{orbitsState?.config?.exploreAspectsHeader || 'Explore all obits aspects, then continue to the challenge'}</div>

                        <TabbedModal
                            data={orbit}
                            tabsOnTop={false}
                            doSlider={false}
                            doAspects={true}
                            selected={currentSelectedAspect || 'sma'}
                            onSliderChange={(header, value) => { }}
                        >

                        </TabbedModal>
                        {
                            view === "exploreorbit" && <Button
                                onClick={() => {
                                    setView('challenge')
                                }}
                                text={'CONTINUE'}
                                className={styles.ContinueButton}>
                                Continue
                            </Button>
                        }
                        {
                            view === "exploreaspects" && <Button
                                onClick={() => {
                                    valuesValidation(selectedUserValues, onContinue)
                                }}
                                className={styles.ContinueButton}
                                text={'CHALLENGE ME'}
                            >
                            </Button>
                        }
                    </>
                )
            }

        </div>
    </div>
}

export default ExploreOrbit;

